/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/elements/icons';
import cx from 'classnames';

import CircleLoader from 'common/components/elements/loader/circle';
import StoryPlayer from 'common/components/modules/story-player';
import Modal from 'common/components/modules/modal';
import UploadImg from 'admin/views/stories/video-story-upload/upload-img';
import Textarea from 'common/components/elements/inputs/textarea';
import { isMobileAndTablet } from 'common/utils/utils';
import SfwCheckbox from 'admin/views/media-modules/sfw-checkbox';
import toast from 'common/utils/toast';

const PosterImages = ({
   videoSrc,
   onPosterImageChange,
   customPosterImage,
   type,
   description,
   onChangeText,
   paths,
   uploadStoryImgs,
   deleteImg,
   onSortPhotosEnd,
   storyIsSfw,
   videoStoryCustomThumbnailIsSfw,
   isCustomThumbnail,
}) => {
   function handleOnChangeText(name, value) {
      if(value.length > 150) {

         toast.error('150 character limit has been reached', {
            toastId: 'max-limit-error',
         })
         return;
      }
      onChangeText(name, value);
   }
   const [videoMode, setVideoMode] = useState(false);
   const [inputValue, setInputValue] = useState('');

   const { loading, warning, full_src } = customPosterImage;
   return (
      <>
         <div className='flex flex-col items-center'>
            <div
               className='w-full flex flex-col gap-4'
            >
               <SfwCheckbox
                  label='This story is SFW'
                  name='is_sfw'
                  checked={ storyIsSfw }
                  onChange={ (_, value) => {
                     onChangeText('is_sfw', value);
                  } }
                  overrideCheckboxLabelProps={ {
                     className: '!px-4',
                     labelClassName: '!w-fit',
                  } }
               />
               {
                  type === 'video' && isCustomThumbnail && (
                     <SfwCheckbox
                        label='This thumbnail is SFW'
                        checked={ videoStoryCustomThumbnailIsSfw }
                        name='custom_thumbnail_is_sfw'
                        onChange={ (_, value) => {
                           onChangeText('custom_thumbnail_is_sfw', value);
                        } }
                        overrideCheckboxLabelProps={ {
                           labelClassName: '!w-fit',
                           className: '!px-4',
                        } }
                     />
                  )
               }
            </div>
            <div
               className={ cx(
                  'w-full border-b bg-panel border-divider',
                  !videoMode && 'overflow-hidden'
               ) }
            >
               {
                  type === 'video' ? (
                     <>
                        <div className='relative mb-8'>
                           <div className='flex justify-center select-none'>
                              {
                                 !videoMode ? (
                                    <div
                                       className='rounded-lg relative overflow-hidden mt-5 w-full h-full'
                                       style={ { height: '230px', width: '200px' } }
                                       onClick={ () => {
                                          if(!loading  && !warning){
                                             setVideoMode(true)
                                          }
                                       } } role='presentation'>
                                       {
                                          (loading || (!warning && !full_src)) ? (
                                             <div
                                                style={ { height: '230px' } }
                                                className='rounded-lg h-full w-full border border-divider flex items-center justify-center'>
                                                <CircleLoader color='major' />
                                             </div>
                                          ) : (
                                             warning ? (
                                                <>
                                                   <label
                                                      htmlFor='poster'
                                                      onClick={ (e) => e.stopPropagation() }
                                                   >
                                                      <div className='w-full h-full border border-divider flex items-center bg-panel justify-center flex-col text-secondary rounded-lg'>
                                                         <Icon
                                                            name='broken-image'
                                                            color='placeholder'
                                                            size='2xl'
                                                         />
                                                         <span className='text-sm block leading-none mt-3 text-error'>Wrong image format</span>
                                                         <span
                                                            className='font-medium block leading-none mt-4'
                                                         >
                                                            Upload again
                                                         </span>
                                                      </div>
                                                   </label>
                                                </>
                                             ) : (
                                                <>
                                                   <div className='absolute' style={ { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } }>
                                                      <Icon name='play-filled' color='major-dark' size='4xl' className='cursor-pointer' />
                                                   </div>
                                                   <img src={ full_src } alt='' className='w-full h-full object-cover' />
                                                </>

                                             )
                                          )
                                       }
                                    </div>
                                 ) : (
                                    videoMode && !loading && !warning && (
                                       <Modal
                                          fullScreenMode={ isMobileAndTablet() }
                                          contentPosition='full-screen'
                                          onClose={ () => setVideoMode(false) }
                                       >
                                          <StoryPlayer
                                             src={ videoSrc }
                                             hasAccess={ true }
                                             isAdmin={ true }
                                             onClickComment={ () => {} }
                                             storyType='video'
                                             onClose={ () => setVideoMode(false) }
                                             showComments
                                          />
                                       </Modal>
                                    )
                                 )
                              }
                           </div>
                           <div
                              style={ { bottom: '8px', opacity: '0.6' } }
                              className='w-full flex justify-center items-center absolute'
                           >
                              <div className='w-42 cursor-pointer select-none relative'>
                                 <label
                                    htmlFor='poster'
                                 >
                                    <div
                                       className='cursor-pointer h-9 rounded-lg flex items-center justify-center bg-panel-dark'>
                                       <Icon
                                          name='upload'
                                          size='xl'
                                          color='major-dark'
                                          className='items-center'
                                       />
                                       <span className='leading-tight text-major-dark font-medium select-none cursor-pointer'>Change thumbnail</span>
                                    </div>
                                 </label>
                                 <input
                                    id='poster'
                                    type='file'
                                    accept='image/png,image/jpeg, image/webp'
                                    className='w-0 h-0 absolute bottom-0 opacity-0 '
                                    onChange={ (e) => {
                                       setInputValue('')
                                       onPosterImageChange(e)
                                    } }
                                    value={ inputValue }
                                 />
                              </div>
                           </div>
                        </div>
                     </>
                  ) : (
                     <>
                        <UploadImg
                           paths={ paths }
                           uploadStoryImgs={ uploadStoryImgs }
                           deleteImg={ deleteImg }
                           onSortPhotosEnd={ onSortPhotosEnd }
                        />
                     </>
                  )
               }

            </div>
            <div style={ { width: '266px' } }>

            </div>
            <div className={ `w-full px-4 flex flex-col select-none ${ type === 'image' ? 'mt-4 justify-between' : 'pt-4 h-32' }` }>
               <Textarea
                  name='description'
                  value={ description ? description : '' }
                  placeholder='Say something about this story...'
                  onChange={ handleOnChangeText }
                  height='24'
               />
               <div className='text-xs text-secondary text-right mt-[6px]'>
                  {(description && description.length) || 0} of 150 characters
               </div>
            </div>
         </div>
      </>
   )
};

PosterImages.propTypes = {
   videoSrc: PropTypes.string,
   onPosterImageChange: PropTypes.func,
   customPosterImage: PropTypes.object,
   description: PropTypes.string,
   type: PropTypes.string,
   onChangeText: PropTypes.func,
   paths: PropTypes.array,
   uploadStoryImgs: PropTypes.func,
   deleteImg: PropTypes.func,
   onSortPhotosEnd: PropTypes.func,
   storyIsSfw: PropTypes.bool,
   videoStoryCustomThumbnailIsSfw: PropTypes.bool,
   isCustomThumbnail: PropTypes.bool,
};

export default memo(PosterImages);
